<template>
  <div class="end-task-wrapper">
    <div class="modal task fancy-scroll">
      <div class="modal-close" @click="close"></div>
      <div class="custom-modal-header">Ende</div>
      <div class="content">
        <div class="url-inputs">
          <div class="form-element">
            <label for="success-url" style="margin-right: 15px"
              >Weiterleitungs URL bei Erfolg</label
            >
            <input
              type="text"
              name="success-url"
              v-model="task.props.successURL"
              placeholder="https://codelos.io/success"
            />
          </div>

          <div class="form-element">
            <label for="error-url" style="margin-right: 15px"
              >Weiterleitungs URL bei Fehler</label
            >
            <input
              type="text"
              name="error-url"
              v-model="task.props.errorURL"
              placeholder="https://codelos.io/error"
            />
          </div>
        </div>
        <div class="html-inputs" v-show="false">
          <label for="success-html">HTML für Erfolg.</label>
          <br />
          <textarea
            type="text"
            name="success-html"
            v-model="task.props.errorHTML"
          ></textarea>
        </div>
        <button class="btn-black" @click="close">Speichern</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'End',
  data() {
    return {};
  },
  methods: {
    close() {
      this.$emit('close');
    },
  },
  props: {
    task: Object,
  },
};
</script>

<style scoped>
@import 'https://use.fontawesome.com/releases/v5.6.3/css/all.css';

.content {
  text-align: center;
  margin-top: 36px;
}
/* Style that has no refference*/
.html {
  margin-top: -100px;
  margin-bottom: 100px;
  margin-right: 14%;
  height: 250px;
}

.content > h1 {
  margin-top: 0px;
  color: #333c4e;
  font-weight: 300;
}

.pull-right {
  float: right;
}

button.pull-right {
  margin-right: 0px;
}

.modal .btn-close {
  margin-top: -60px;
  margin-right: -10px;
}

.btn-black {
  cursor: pointer;
  text-decoration: none;
  color: rgba(255, 255, 255, 0.951);
  border: 3px solid rgba(0, 0, 0, 0.916);
  background-color: rgba(0, 0, 0, 0.916);
  border-radius: 0.375em;
  font-family: proxima-nova, Helvetica Neue, Arial, sans-serif;
  font-weight: 400;
  line-height: 23px;
  padding: 0.6rem 1.6rem;
  font-size: 0.9375rem;
  margin-top: 25px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
}

.btn-black:hover {
  color: #fff;
  border: 3px solid #353434;
  background-color: #353434;
}

label {
  float: left;
}

.end-task-wrapper {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.end-task-wrapper .url-inputs {
  display: flex;
  flex-direction: column;
  gap: 15px;
  align-items: start;
  margin-bottom: 135px;
}

.end-task-wrapper .url-inputs .form-element {
  display: flex;
  justify-content: center;
  align-items: center;
}
.end-task-wrapper .url-inputs .form-element label {
  font-size: 16px;
  color: #151515;
  min-width: 220px;
  text-align: left;
}
.end-task-wrapper .url-inputs .form-element input {
  font-size: 18px !important;
  width: 300px !important;
  outline: none !important;
}
</style>
